import React from 'react'

import Lightbox from 'react-image-lightbox'

import { Swiper, SwiperSlide } from 'swiper/react'
import useWindowSize from '../hooks/UseWindowSize'

const SLIDES_PER_VIEW = 3

export default (props) => {
  const [data, setData] = React.useState(props.data)
  const [lightBoxOpen, setLightBoxOpen] = React.useState(false)
  const [activeImage, setActiveImage] = React.useState(0)
  const [slideDim, setSlideDim] = React.useState(null)
  const ref = React.useRef(null)
  React.useEffect(() => setData(props.data), [props.data])

  // this dirty hack is to rerender on browser resize to resize the slides... DO NOT REMOVE OR FIND BETTER WAY
  useWindowSize()

  React.useEffect(() => {
    setData([...data])
    setSlideDim(ref.current?.offsetWidth / SLIDES_PER_VIEW)
  }, [ref.current])
  // end of hack

  const onClick = (index) => {
    setActiveImage(index)
    setLightBoxOpen(!lightBoxOpen)
  }

  const edgeSlidesClick = React.useCallback((index) => {
    onClick(index)
  }, [])

  React.useEffect(() => {
    const firstSlide = document.querySelector('.swiper-slide-prev')
    const lastSlide = document.querySelector('.swiper-slide-duplicate-next')

    if (firstSlide) {
      firstSlide.addEventListener('click', () =>
        edgeSlidesClick(data.length - 1)
      )
      firstSlide.previousSibling?.addEventListener('click', () =>
        edgeSlidesClick(data.length - 2)
      )
    }
    if (lastSlide) {
      lastSlide.addEventListener('click', () => edgeSlidesClick(1))
      lastSlide.previousSibling?.addEventListener('click', () =>
        edgeSlidesClick(0)
      )
    }
    return () => {
      if (firstSlide) {
        firstSlide.removeEventListener('click', () => edgeSlidesClick())
        firstSlide.previousSibling?.removeEventListener('click', () =>
          edgeSlidesClick()
        )
      }
      if (lastSlide) {
        lastSlide.addEventListener('click', () => edgeSlidesClick())
        lastSlide.previousSibling?.addEventListener('click', () =>
          edgeSlidesClick()
        )
      }
    }
  }, [edgeSlidesClick])

  const customStyles = {
    overlay: {
      zIndex: '1000'
    },
    bodyOpen: {
      position: 'fixed'
    }
  }

  return (
    <div ref={slideDim && props.innerRef ? props.innerRef : null}>
      <div ref={ref}>
        {slideDim > 0 && data && data.length > 0 && (
          <div style={{ height: slideDim }}>
            <Swiper slidesPerView={3}>
              {data.map((item, index) => (
                <SwiperSlide key={index}>
                  {/* <Image todo: use this when https://github.com/vercel/next.js/discussions/18429 addressed as insta cdn always change url */}
                  <img
                    className='img-gallery'
                    // placeholder="blur"
                    // blurDataURL="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mOsLQIAAXIA8T4mPVAAAAAASUVORK5CYII="
                    src={item.url}
                    style={{
                      objectFit: 'cover',
                      height: slideDim,
                      width: slideDim
                    }}
                    onClick={() => onClick(index)}
                  />
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        )}
      </div>

      {lightBoxOpen && (
        <Lightbox
          mainSrc={data[activeImage].url}
          nextSrc={data[(activeImage + 1) % data.length].url}
          prevSrc={data[(activeImage + data.length - 1) % data.length]}
          onCloseRequest={() => setLightBoxOpen(false)}
          // imageCaption={data[activeImage].title}
          onMovePrevRequest={() =>
            setActiveImage((activeImage + data.length - 1) % data.length)
          }
          onMoveNextRequest={() =>
            setActiveImage((activeImage + 1) % data.length)
          }
          enableZoom={false}
          reactModalStyle={customStyles}
        />
      )}
    </div>
  )
}
